// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
export type OfferingPackageImageOfferingPackageFragment = {
  __typename?: 'OfferingPackage';
  id: string;
  imageLink?: string | null;
  name: string;
};

export const OfferingPackageImageOfferingPackageFragmentDoc = gql`
  fragment OfferingPackageImage_OfferingPackage on OfferingPackage {
    id
    imageLink
    name
  }
`;
